var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showopenmodal
        ? _c(
            "div",
            [
              _c("transition", { attrs: { name: "modal" } }, [
                _c("div", { staticClass: "modal-mask" }, [
                  _c("div", { staticClass: "modal-wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass: "modal-dialog modal-md",
                        staticStyle: { display: "block !important" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "modal-content cps-content" },
                          [
                            _c("div", { staticClass: "cps-header" }, [
                              _c("div", { staticClass: "cps-header-icon" }, [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("share"),
                                ]),
                              ]),
                              _c("div", { staticClass: "cps-header-text" }, [
                                _c("h5", { staticClass: "cps-title" }, [
                                  _vm._v("Consolidated Print Sections"),
                                ]),
                                _c("p", { staticClass: "cps-subtitle" }, [
                                  _vm._v(
                                    "\n                                        Choose which sections appear on the consolidated print\n                                    "
                                  ),
                                ]),
                              ]),
                              _c(
                                "button",
                                {
                                  staticClass: "cps-close",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.cancelAction()
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("close"),
                                  ]),
                                ]
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "cps-body" },
                              [
                                _vm.showspinner
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "appointmentlist-spinner",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "processing_popup full-spinner",
                                            staticStyle: {
                                              visibility: "visible",
                                              top: "0",
                                              height: "100%",
                                              "z-index": "9999999999",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "spinner cover-spin",
                                              },
                                              [
                                                _c("div", {
                                                  staticClass: "bounce1",
                                                }),
                                                _c("div", {
                                                  staticClass: "bounce2",
                                                }),
                                                _c("div", {
                                                  staticClass: "bounce3",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "cps-section-label" },
                                  [_vm._v("PRINT SECTIONS")]
                                ),
                                _vm._l(_vm.sections, function (section) {
                                  return _c(
                                    "label",
                                    {
                                      key: section.value,
                                      staticClass: "cps-card",
                                      attrs: { for: "cps-" + section.value },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "cps-icon",
                                          style: {
                                            background: _vm.meta(section.value)
                                              .bg,
                                            color: _vm.meta(section.value).fg,
                                          },
                                        },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.meta(section.value).icon
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "cps-card-text" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "cps-card-title" },
                                            [_vm._v(_vm._s(section.label))]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "cps-card-desc" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.meta(section.value).desc
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "cps-switch" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.selectedSections,
                                                expression: "selectedSections",
                                              },
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              id: "cps-" + section.value,
                                            },
                                            domProps: {
                                              value: section.value,
                                              checked: Array.isArray(
                                                _vm.selectedSections
                                              )
                                                ? _vm._i(
                                                    _vm.selectedSections,
                                                    section.value
                                                  ) > -1
                                                : _vm.selectedSections,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a = _vm.selectedSections,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = section.value,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.selectedSections =
                                                        $$a.concat([$$v]))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.selectedSections =
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                  }
                                                } else {
                                                  _vm.selectedSections = $$c
                                                }
                                              },
                                            },
                                          }),
                                          _c("span", {
                                            staticClass: "cps-slider",
                                          }),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                !_vm.sections.length && !_vm.showspinner
                                  ? _c("div", { staticClass: "cps-empty" }, [
                                      _vm._v(
                                        "\n                                    No sections available\n                                "
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _c("div", { staticClass: "cps-footer" }, [
                              _c("div", { staticClass: "cps-note" }, [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("info"),
                                ]),
                                _vm.selectedSections.length
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                                        Changes apply immediately for all users on reload\n                                    "
                                      ),
                                    ])
                                  : _c(
                                      "span",
                                      { staticClass: "cps-note-warn" },
                                      [_vm._v("Select at least one section")]
                                    ),
                              ]),
                              _c(
                                "button",
                                {
                                  staticClass: "cps-save",
                                  attrs: {
                                    type: "button",
                                    disabled:
                                      !_vm.selectedSections.length ||
                                      _vm.showspinner,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.saveSettings()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    Save Changes\n                                "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.isdisplaymsg
        ? _c("Messages", {
            attrs: {
              datamessage: _vm.sucessmsgtext,
              iserror: _vm.iserrormsg,
              isVisible: _vm.isdisplaymsg,
            },
            on: { closemsg: _vm.closeMessage },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }